import React from 'react';
import {Row, Col, Form, Select, Input, InputNumber, Tooltip, Button} from 'antd';
import {connect} from 'react-redux';

const InputGroup = Input.Group;
const Option = Select.Option;

const formItemLayout = {
    labelCol: {span: 4, offset: 2},
    wrapperCol: {span: 16},
};

class DeviceTagCondition extends React.Component {


    // 处理标签名称改变
    handleTagNameChange = (index, selectValue) => {
        const {value, onChange} = this.props;
        let changeVal, array;
        if (index >= value.length) {
            array.put({tagName: selectValue});
            changeVal = array;
        } else {
            value[index].tagName = selectValue;
            value[index].tagValues = [];
            changeVal = value;
        }
        onChange(changeVal);
    }

    // 处理标签条件改变
    handleTagConditionChange = (index, selectValue) => {
        const {value, onChange} = this.props;
        //通知父组件更新,封装数据传参
        let changeVal, array;
        if (index >= value.length) {
            array.put({condition: selectValue});
            changeVal = array;
        } else {
            value[index].condition = selectValue;
            changeVal = value;
        }
        onChange(changeVal);
    }

    // 处理标签值改变
    handleTagValuesChange = (index, selectValue) => {
        const {value, onChange} = this.props;
        let changeVal, array;
        if (index >= value.length) {
            array.put({tagValues: selectValue});
            changeVal = array;
        } else {
            value[index].tagValues = selectValue;
            changeVal = value;
        }
        onChange(changeVal);
    }


    // 添加标签
    addTag = () => {
        const {value, onChange} = this.props;
        value.push({tagName: this.props.deviceTagData[0].k, condition: 0, tagValues: []});
        onChange(value);
    };

    // 删除标签
    delTag = index => {
        const {value, onChange} = this.props;
        value.splice(index, 1);
        onChange(value);
    };


    render() {
        const {value, deviceTagData, disabled} = this.props;
        const inputPile = [];
        for (let i = 0; i < value.length; i++) {
            // for循环数组
            let index = i;
            inputPile.push(
                //将组件塞入定义的数组中
                <InputGroup>

                    <Select
                        placeholder="请选择标签名称"
                        style={{width: '25%', margin: '0 8px 8px 0'}}
                        showSearch={true}
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        value={value[index].tagName == undefined ? '' : value[index].tagName}
                        onChange={(selectValue) => this.handleTagNameChange(index, selectValue)}
                        disabled={disabled}
                    >
                        {deviceTagData.map((tag, index) => {
                            return (
                                <Option key={tag.k} title={tag.v.k} value={tag.k}>
                                    {tag.v.k}
                                </Option>
                            );
                        })}
                    </Select>

                    <Select
                        placeholder="请选择标签条件"
                        style={{width: '17%', margin: '0 8px 8px 0'}}
                        value={value[index].condition == undefined ? 0 : value[index].condition}
                        onChange={(selectValue) => this.handleTagConditionChange(index, selectValue)}
                        disabled={disabled}
                    >
                        <Option value={0}>等于</Option>
                        <Option value={1}>不等于</Option>
                        <Option value={2}>包含</Option>
                        <Option value={3}>不包含</Option>
                        <Option value={4}>大于</Option>
                        <Option value={5}>小于</Option>
                        <Option value={6}>大于等于</Option>
                        <Option value={7}>小于等于</Option>
                    </Select>

                    <Select
                        placeholder="请选择标签值"
                        style={{width: '30%', margin: '0 8px 8px 0'}}
                        mode="tags"
                        showSearch={true}
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        value={value[index].tagValues == undefined ? [] : value[index].tagValues}
                        onChange={(selectValue) => this.handleTagValuesChange(index, selectValue)}
                        disabled={disabled}
                    >
                        {deviceTagData.filter(item =>
                            item.k === value[index].tagName
                        )[0].v.v.map((tag, index) => {
                            return (
                                <Option key={tag.k} title={tag.v} value={tag.k}>
                                    {tag.v}
                                </Option>
                            );
                        })}
                    </Select>


                    {i == 0 ? (
                        <Tooltip placement="top" title="添加条件标签">
                            <Button
                                shape="circle"
                                icon="plus"
                                size="small"
                                type="primary"
                                style={{margin: '4px 0 0 8px'}}
                                onClick={() => {
                                    this.addTag();
                                }}
                            />
                        </Tooltip>
                    ) : (
                        <Tooltip placement="top" title="删除条件标签">
                            <Button
                                shape="circle"
                                icon="minus"
                                size="small"
                                type="danger"
                                style={{margin: '4px 0 0 8px'}}
                                onClick={() => {
                                    this.delTag(i);
                                }}
                            />
                        </Tooltip>
                    )}
                </InputGroup>
                ,
            );
        }

        return <div>{inputPile}</div>;
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Form.create()(DeviceTagCondition));



// WEBPACK FOOTER //
// ./pages/assist/deviceIndex/components/DeviceTagCondition.js